import { useRequiredParam } from '@/hooks/useRequiredParam';
import { GRATAnnuitiesPage } from '@/modules/entities/details/grat/GRATAnnuitiesPage/GRATAnnuitiesPage';

export function EntityPaymentsPage() {
  const entityId = useRequiredParam('entityId');
  // TODO: currently only supporting GRATs; when we move to supporting payments pages for other trust types,
  // we should lift up the querying logic to this level
  return <GRATAnnuitiesPage entityId={entityId} />;
}
